import type { CompanySummary } from '@/hooks/useCompanySummary';

/**
 * Mock company summary counts for demo mode
 */
export const mockSummary: CompanySummary = {
  totalCompanies: 42,
  activeIntegrations: 8,
  activeUsers: 156,
  documentTemplates: 15,
};
